angular.module('st')
    .controller('customerOrderLookUpController', [
        '$rootScope', '$scope', '$http', '$window', '$timeout',
        function ($rootScope, $scope, $http, $window, $timeout) {
            var ctrl = this;
            $scope.isError = false;
            $scope.feedback = '';
            $scope.processing = false;
            $scope.refundSubmitted = false;
            $scope.last4Digits = null;
            $scope.memberId = null;
            $scope.bookingDate = null;
            $scope.isMidtownWebsite = false;
            $scope.loyaltyVouchers = [];
            $scope.bookings = [];


            ctrl.IsFieldInvalid = function (field) {
                return field.$invalid && (field.$touched || $scope.frm.$submitted);
            }

            ctrl.ToCurrency = function(value) {
                value = _.isNumber(value) ? value : 0;

                value = value/100;

	            if (typeof value !== "number") {
		            return value;
	            }

	            var formatter = new Intl.NumberFormat('en-US', {
		            style: 'currency',
		            currency: 'USD',
		            minimumFractionDigits: 2
	            });

	            return formatter.format(value);
            };


            var clear = function () {
                $scope.feedback = null;
                $scope.isError = false;
                ctrl.last4DigitsInvalid = false;
                ctrl.memberIdInvalid = false;
                ctrl.bookingDateInvalid = false;
            };

            var isValidDate = function(dateString) {
                 const date = moment(dateString, "MM-DD-YYYY", true); // Strict parsing
                 return date.isValid();
            }

            var isStringOfNumbers = function(str) {
              return _.isString(str) && /^[0-9]+$/.test(str);
            }

            var validateFields = function () {
                //console.log('date:' + $scope.bookingDate, 'last4:' + $scope.last4Digits, 'memberid:' + $scope.memberId);
                var hasDate = !_.isEmpty($scope.bookingDate) && isValidDate($scope.bookingDate);
                
                if (!hasDate) {
                    ctrl.bookingDateInvalid = true;
                    $scope.feedback = 'Invalid date, must be formatted MM-DD-YYYY, i.e. 01-24-2025';
                    return false;
                }

                var hasOneOptionallyRequiredField = !_.isEmpty($scope.memberId) || !_.isEmpty($scope.last4Digits);
                if (!hasOneOptionallyRequiredField) {
                    ctrl.last4DigitsInvalid = true;
                    ctrl.memberIdInvalid = true;
                    $scope.feedback = 'Either the "C Rewards Member ID" or "last 4 payment card digits" that were used during your booking must be filled in.';
                    return false;
                }

                if (!_.isEmpty($scope.last4Digits)) {
                    if (!isStringOfNumbers($scope.last4Digits)) {                        
                        ctrl.last4DigitsInvalid = true;
                        $scope.feedback = 'The "last 4 payment card digits" must be exactly four numbers in length, numbers only. (0-9)';
                        return false;
                    }

                    if ($scope.last4Digits.length !== 4) {
                        ctrl.last4DigitsInvalid = true;
                        $scope.feedback = 'The "last 4 payment card digits" must have exactly 4 numbers';
                        return false;
                    }
                }

                return true;
            }
function getDateFromAspNetFormat(dateString) {
    var dateStr = dateString.replace(/\//g, "");
    dateStr = dateStr.replace("(", "");
    dateStr = dateStr.replace(")", "");
    dateStr = dateStr.replace("Date", "");

  //const timestamp = parseInt(dateString.toString().replace(/\/Date\((\d+)\)\//, '$1'), 10);
console.log('parsed', dateStr);
const timestamp = parseInt(dateStr);
  return timestamp;
}
            ctrl.getSeats = function (booking) {
                var seats = "";
                if (!booking || !booking.Tickets) return seats;

                const collectionSize = _.isArray(booking.Tickets) ? booking.Tickets.length : _.keys(booking.Tickets).length;
                if (!_.isEmpty(booking) && !_.isEmpty(booking.Tickets)) {
                    _.each(booking.Tickets, (value, key) => {
                        const isLast = (collectionSize - 1) === key;
                        var seatStr = value.SeatRowId + "-" + value.SeatNumber;

                        if (!isLast) {
                            seatStr = seatStr + ", ";
                        }

                        seats = seats + seatStr;
                    });
                }
                return seats;
            }

ctrl.dateTime = function(epoch) {
                                 var time = moment(epoch).format('dddd, MMMM Do, YYYY h:mm A');
                                 return time;
}
ctrl.dateTimeTime = function(epoch) {
                                 var time = moment(epoch).format('h:mm A');
                                 return time;
}
ctrl.dateTimeDate = function(epoch) {
                                 var time = moment(epoch).format('MMMM Do');
                                 return time;
}

            ctrl.loadBooking = function () {
                if ($scope.processing == false) {
                    clear();
                    $scope.processing = true;
                    $scope.feedback = 'Loading booking data...';
                    
                    var valid = validateFields();

                    if (!valid) {
                        $scope.processing = false;                        
                        $scope.isError = true;
                        goToError();
                        return;
                    }

                    grecaptcha.ready(function () {
                        grecaptcha.execute($('#captcha-site-key').val(), { action: 'crewards_order_lookup' }).then(function (token) {
                            var url = "/rpc/order/bookingsearch";
                          
                            var config = {
                                bookingDate: $scope.bookingDate,
                                memberId: $scope.memberId,
                                last4Digits: $scope.last4Digits,
                                token: token
                            };

                            $http.post(url, config)
                                .then(function (d) {
                                    console.log(d);
                                    if (d.data.Success == true) {
                                        $scope.bookings = d.data.Data.map(function (item) {
                                            var booking = item.BookingResult;
                                            booking.sessionInfo = item.Session;

                                            // Calculate session time for each booking
                                            if (booking.Tickets && booking.Tickets.length > 0) {
                                                var sessionTime = booking.Tickets[0].SessionDateTime;
                                                if (sessionTime) {
                                                    booking.SessionDateTime = getDateFromAspNetFormat(sessionTime);
                                                }
                                            }
                                            return booking;
                                        });

                                        $scope.feedback = '';
                                        if ($scope.bookings.length === 0) {
                                            $scope.feedback = 'No bookings found for the provided criteria.';
                                            $scope.isError = true;
                                            goToError();
                                        } else {
                                            goToBooking();
                                        }
                                        //var result = d.data.Data;
                                        //$scope.bookingData = result.BookingResult;
                                        //$scope.sessionInfo = result.Session;
                                        //var sessionTime = $scope.bookingData.Tickets[0].SessionDateTime;
                                        //if (sessionTime) {
                                        //    var epoch = getDateFromAspNetFormat(sessionTime);
                                        //    ctrl.SessionDateTime = epoch;           
                                        //}
                                        //console.log(sessionTime);
                                        //$scope.feedback = '';
                                        //goToBooking();                              
                                    } else {
                                        // vista error 
                                        var message = _.get(d.data ,'Message');
                                        if (_.isEmpty(message)) {
                                            var parse = JSON.parse(d.data);
                                            message = _.get(parse, 'Message');
                                        }
                                        $scope.feedback = 'Error: ' + message;
                                        $scope.isError = true;

                                        goToError();
                                    }
                                    $scope.processing = false;
                                }).catch(function (error) {
                                    console.log(arguments, error);
                                    // our server error 
                                    $scope.processing = false;
                                    $scope.feedback = 'Error occurred while trying to submit the refund.';
                                    $scope.isError = true;
                                        goToError();
                                });
                        });
                    });
                }
            };

            var goToError = function() {
                $timeout(function() {
                                            var bottom = $("#error-found").offset().top;
                                            const element = document.getElementById('error-found');
                                            const middleOfElm = element.offsetHeight;
                                            var middle = bottom-middleOfElm;
                                            $('html, body').animate({
                                                scrollTop: middle
                                            },1000);
                                        }, 1);
            }

var goToBooking = function() {
$timeout(function() {
                                            var bottom = $("#booking-id-found").offset().top;
    const element = document.getElementById('booking-id-found');

                                            const middleOfElm = element.offsetHeight;
    var middle = bottom - middleOfElm;


    var newmiddle = middle - 100;
                                            $('html, body').animate({
                                                scrollTop: newmiddle
                                            },1000);
                                        }, 1);   
}

            $scope.$watch(function() {
                    return $window.MEMBER_ID;
                }, function(newValue, oldValue) {
                if (newValue !== oldValue) {        
                    console.log('member id found', oldValue, 'to', newValue);
                    $scope.memberId = $window.MEMBER_ID;
                }
            });

            ctrl.cancel = function () {
                clear();
            };
        }
    ]);
